import {BILL_TODO_TYPE_LABELS} from '../../../../../types/enums.ts';
import type {BillTodoType, DateFilterType, DocumentCategory, DocumentsToCheckOrderByEnum, OrderDirectionEnum, ToCheckReason} from '../../../../../generated/enums.ts';

export const CAN_SEE_DOCUMENT_TODOS_FLAG = 'PARTNER__CAN_SEE_DOCUMENT_TODOS';

export interface DocumentToCheck {
    id: string;
    bill_id: string | null;
    reason: ToCheckReason | null;
    todos: BillTodoType[];
    business_id: string;
    business_name: string;
    file_name: string;
    mime_type: string;
    document_category: DocumentCategory | null;
    created_at: string;
    invoice_date: string | null;
}

export interface DocumentsToCheckFilters {
    dateFrom: string;
    dateTo: string;
    dateType: DateFilterType;
    customerId: string;
    reasons: ToCheckReason[];
    todoTypes: BillTodoType[];
}

export interface DocumentsToCheckSorting {
    orderby: DocumentsToCheckOrderByEnum;
    order: OrderDirectionEnum;
}

export const DEFAULT_SORTING: DocumentsToCheckSorting = {
    orderby: 'created_at',
    order: 'desc',
};

export type DocumentsToCheckStatus = ToCheckReason | BillTodoType;

export function splitStatuses(
    statuses: DocumentsToCheckStatus[],
): { reasons: ToCheckReason[]; todoTypes: BillTodoType[] } {
    const isTodoType = (status: DocumentsToCheckStatus): status is BillTodoType => status in BILL_TODO_TYPE_LABELS;

    return {
        reasons: statuses.filter((status): status is ToCheckReason => !isTodoType(status)),
        todoTypes: statuses.filter(isTodoType),
    };
}
